import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  AuthCodeData,
  LoginFormData,
  LoginInitResult,
  LoginResult,
} from "./auth.type";
import { ApiBaseUrl, AppBaseUrl, env } from "@/redux/http";

// AuthApi keeps its own fetchBaseQuery, not baseQueryWithLogout: its calls
// run before (login, code) or while ending (logout) a session, so a 401 there
// is a wrong code, not a lost session, and no restaurant header must be sent.
// The current user is read through UserApi, where a lost session (401, or 404
// on users/current) triggers the logout flow (SFRESTO-167).
export const AuthApi = createApi({
  reducerPath: "authApi",
  tagTypes: ["auth"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
  }),
  endpoints: (build) => ({
    loginUser: build.mutation<LoginInitResult, LoginFormData>({
      query: (data) => ({
        url: "login",
        method: "POST",
        body: data,
        headers: {
          "X-Origin": env === "dev" ? "http://localhost:3000" : AppBaseUrl,
        },
      }),
      invalidatesTags: ["auth"],
    }),

    authByCode: build.mutation<LoginResult, AuthCodeData>({
      query: (data) => ({
        url: "auth_code",
        method: "POST",
        body: data,
        headers: {
          "X-Origin": env === "dev" ? "http://localhost:3000" : AppBaseUrl,
        },
        credentials: "include",
      }),
      invalidatesTags: ["auth"],
    }),

    logout: build.mutation<void, void>({
      query: () => ({
        url: "logout",
        method: "POST",
        // The session lives in a cookie on the API origin.
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useLoginUserMutation,
  useLogoutMutation,
  useAuthByCodeMutation,
} = AuthApi;
